import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconErrorSvg } from "./IconErrorSvg.mjs";
const IconError = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconErrorSvg, ...iconProps });
};
export {
  IconError
};
